"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeeTokenFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_initialAmount",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_tokenName",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "_decimalUnits",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_tokenSymbol",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "_basisPointFee",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "allocateTo",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "basisPointFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class FeeTokenFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, _basisPointFee, _owner, overrides) {
        return super.deploy(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, _basisPointFee, _owner, overrides || {});
    }
    getDeployTransaction(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, _basisPointFee, _owner, overrides) {
        return super.getDeployTransaction(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, _basisPointFee, _owner, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.FeeTokenFactory = FeeTokenFactory;
FeeTokenFactory.bytecode = _bytecode;
FeeTokenFactory.abi = _abi;
//# sourceMappingURL=FeeTokenFactory.js.map